module.exports = __webpack_public_path__ + "static/media/CD.b55fb010.png";